import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "aiQuizCreatorContainer"
};
const _hoisted_2 = {
  class: "aiQuizHeader"
};
const _hoisted_3 = {
  class: "aiQuizHeaderLeftPart"
};
const _hoisted_4 = {
  class: "aiQuizHeaderTitle"
};
const _hoisted_5 = {
  class: "aiQuizHeaderRightPart"
};
const _hoisted_6 = {
  class: "popupRow"
};
const _hoisted_7 = {
  class: "additionalInfoPopup"
};
const _hoisted_8 = {
  class: "iconPopup"
};
const _hoisted_9 = {
  class: "messagePopup"
};
const _hoisted_10 = {
  class: "messagePopup"
};
const _hoisted_11 = {
  class: "dropdownPopup"
};
const _hoisted_12 = {
  class: "messagePopup"
};
const _hoisted_13 = {
  class: "inputPopup"
};
const _hoisted_14 = {
  class: "question-mode-selector"
};
const _hoisted_15 = {
  class: "messagePopup"
};
const _hoisted_16 = {
  class: "inputPopup"
};
const _hoisted_17 = {
  class: "question-mode-selector"
};
const _hoisted_18 = {
  class: "dialog-footer"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_w_select = _resolveComponent("w-select");
  const _component_w_radio_group = _resolveComponent("w-radio-group");
  const _component_w_slider = _resolveComponent("w-slider");
  const _component_AIQuizSubChapterSelect = _resolveComponent("AIQuizSubChapterSelect");
  const _component_Loader = _resolveComponent("Loader");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_icon, {
      icon: "creation-outline",
      size: "default",
      class: _normalizeClass('aiQuizHeaderTitleIcon')
    }), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("aiQuizGeneration.header")), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_w_tool_tip, {
      text: _ctx.$t('aiQuizGeneration.noMoreThan50Questions'),
      disabled: _ctx.nbQuestionsAllowed > 0,
      placement: "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_standard_button, {
        class: "uploadDocumentButton",
        outlined: true,
        disabled: _ctx.nbQuestionsAllowed <= 0,
        onAction: _cache[0] || (_cache[0] = $event => _ctx.openPopUp())
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "creation-outline"
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t("aiQuizGeneration.generateTitle")), 1)]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    }, 8, ["text", "disabled"])])])])]),
    _: 1
  }), _createVNode(_component_w_dialog, {
    visible: _ctx.generationPopup,
    title: _ctx.$t('aiQuizGeneration.generateTitle'),
    onOnDialogClose: _ctx.closeGenerationPopup,
    "append-to-body": true
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_18, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.cancel'),
      onAction: _ctx.closeGenerationPopup
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      onAction: _ctx.generateAIQuiz,
      disabled: _ctx.generationInProgress || _ctx.selectedChapters.length === 0 && _ctx.questionSelectChapters !== 'full'
    }, {
      default: _withCtx(() => [!_ctx.generationInProgress ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('aiQuizGeneration.popup.buttonGenerate')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_20, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('aiQuizGeneration.popup.generationTooltip')
      }, {
        default: _withCtx(() => [_createVNode(_component_Loader, {
          "spinner-size": "small",
          class: "spinnerElement",
          "spinner-color": "lightSpinner"
        })]),
        _: 1
      }, 8, ["text"])]))]),
      _: 1
    }, 8, ["onAction", "disabled"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_icon, {
      icon: "information-outline",
      size: "default"
    })]), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("aiQuizGeneration.popup.additionalInfo")), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('aiQuizGeneration.language.title')), 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_w_select, {
      placeholder: _ctx.$t('aiQuizGeneration.language.placeholder'),
      options: _ctx.listOfLanguage,
      value: _ctx.selectedLang,
      onChange: _ctx.onLanguageChange
    }, null, 8, ["placeholder", "options", "value", "onChange"])]), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("aiQuizGeneration.popup.message")), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_w_radio_group, {
      class: "radio-group",
      modelValue: _ctx.questionGenerationMode,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.questionGenerationMode = $event),
      onChange: _ctx.onQuestionModeChange,
      options: _ctx.questionModeOptions,
      disabled: _ctx.generationInProgress
    }, null, 8, ["modelValue", "onChange", "options", "disabled"])]), _createVNode(_Transition, {
      name: "zoom"
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_w_slider, {
        modelValue: _ctx.nbCustomQuestions,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.nbCustomQuestions = $event),
        onInput: _ctx.onNbCustomQuestionsChange,
        marks: _ctx.marks,
        min: 1,
        max: _ctx.nbQuestionsAllowed,
        "show-input": true,
        disabled: _ctx.questionGenerationMode === 'auto' || _ctx.generationInProgress
      }, null, 8, ["modelValue", "onInput", "marks", "max", "disabled"]), [[_vShow, _ctx.questionGenerationMode !== 'auto']])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("aiQuizGeneration.popup.selectChapters")), 1), _createElementVNode("div", _hoisted_16, [!_ctx.isAutoTransriptFullyReady ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 0,
      text: _ctx.$t('aiQuizGeneration.popup.needToProceed')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "alert-outline",
        class: "warningProceed"
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_createVNode(_component_w_radio_group, {
      class: "radio-group",
      modelValue: _ctx.questionSelectChapters,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.questionSelectChapters = $event),
      options: _ctx.questionChaptersOptions,
      disabled: _ctx.generationInProgress
    }, null, 8, ["modelValue", "options", "disabled"])]), _createVNode(_Transition, {
      name: "zoom"
    }, {
      default: _withCtx(() => [_ctx.fullSpeach ? (_openBlock(), _createBlock(_component_AIQuizSubChapterSelect, {
        key: 0,
        speach: _ctx.fullSpeach,
        onSelect: _ctx.changeSelectedChapters,
        disabled: _ctx.questionSelectChapters === 'full' || _ctx.generationInProgress,
        onForceRegenerateTranscript: _ctx.forceRegenerateTranscript
      }, null, 8, ["speach", "onSelect", "disabled", "onForceRegenerateTranscript"])) : _createCommentVNode("", true)]),
      _: 1
    })])])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"])]);
}